module.exports = __webpack_public_path__ + "assets/img/Type E (84).1091a5b7.jpg";